<!-- On vérifie que le rootForm existe avant de créer les champs liés -->
<div *ngIf="rootForm && lieuxPolgend && ! (modeRenduService.enModeImpression$ | async)">
  <div class="form-row mx-2 pb-3" *ngIf="rootForm && lieuxPolgend">
    <div class="col" [formGroup]="rootForm">
      <div>
      <mat-accordion class=" col-12">
        <div *ngFor="let item of lieuxPolgend.controls; let i = index">
          <mat-expansion-panel (opened)="setStep(i)">
            <mat-expansion-panel-header>
              <mat-panel-description>
                <mat-icon>account_circle</mat-icon>&#xA0;
                <span [ngClass]="{'onglet-invalide': lieuxPolgend.controls[i].invalid}">
                  Informations sur le commissariat/gendarmerie {{ i + 1 }}
                </span>
                <button *ngIf="(modeRenduService.enModeSaisie$ | async)" (click)="supprimerLieuxPolgend(i)" class="btn-danger btn-sm ml-auto"
                  title="Supprimer le commissariat/gendarmerie">
                  <i class="material-icons md-18">delete</i>
                </button>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="form-row">
                <div class="col-md-8">
                   <!--<bis-filtered-select-input-keypad [preId]="i" [rootForm]="lieuxPolgend.controls[i]" 
                      nbChoixVisiblePossible="5" label="aaLieuPolgendCodCom" nomNomenclature="commune">
                   </bis-filtered-select-input-keypad>-->
                   <bis-commune-input-keypad [rootForm]="lieuxPolgend.controls[i]" [preId]="i" nbChoixVisiblePossible=10
                      label="aaLieuPolgendCodCom" nomNomenclature="commune">
                   </bis-commune-input-keypad>
                 </div>
                 <div class="col-md-4">
                   <bis-filtered-select-input-keypad [preId]="i" [rootForm]="lieuxPolgend.controls[i]" 
                   infoBulle="Préciser dans le menu déroulant si le lieu de permanence est en quartier prioritaire" label="aaLieuPolgendQp" nomNomenclature="ouiNonNsp">
                   </bis-filtered-select-input-keypad>
                 </div>
            </div>
            <div class="form-row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                   <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxPolgend.controls[i]" classeColLabel="col-8" classeColInput="col-2" classeSupplInput="text-right" 
                   label="aaLieuPolgendNbPerm" [max]="999" infoBulle="1 demi-journée = 3h" [erreursCroisees]="['ctrlA66Polgend']">
                   </bis-integer-inline-input-keypad>
                   <bis-affiche-erreurs-croisees [rootForm]="lieuxPolgend.controls[i]" colorErreur="danger"
                    labelErreur="ctrlA66Polgend">
                   </bis-affiche-erreurs-croisees>
                 </div>
            </div>
            <div class="form-row">
                 <div class="col-md-1"></div>
                 <div class="col-md-10">
                    <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxPolgend.controls[i]" classeColLabel="col-8" 
                      classeColInput="col-2" classeSupplInput="text-right" label="aaLieuPolgendNbPermEtp" [max]="9999" [erreursCroisees]="['ctrlA67Polgend']"
                      infoBulle="3 personnes présentes sur une demi-journée = 3 demi-journées travaillées">
                    </bis-integer-inline-input-keypad>
                    <bis-affiche-erreurs-croisees [rootForm]="lieuxPolgend.controls[i]" colorErreur="danger"
                      labelErreur="ctrlA67Polgend">
                    </bis-affiche-erreurs-croisees>
                    <bis-affiche-alertes [labelAlerte]="'alertA45Polgend_' + i"></bis-affiche-alertes>
                 </div>
            </div>
            <div class="form-row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                   <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxPolgend.controls[i]" classeColLabel="col-8" classeColInput="col-2" classeSupplInput="text-right" 
                   label="aaLieuPolgendNbVict" [max]="99999" infoBulle="(physiques et morales)">
                   </bis-integer-inline-input-keypad>
                </div>
           </div>
        </mat-expansion-panel>
        </div>
        </mat-accordion>

        <button *ngIf="modeRenduService.enModeSaisie$ | async" class="mt-4 ml-n1 btn btn-info"
        (click)="ajouterLieuxPolgend()">Ajouter un commissariat/gendarmerie</button>

        <div class="form-row mt-4">
            <div class="col-md-6">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuPolgendNb" [max]="99" enLectureSeule="true"
                classeColLabel="col-6" classeColInput="col-4"      
                infoBulle="Cette zone est calculée automatiquement à partir du nombre de commissariat/gendarmerie ajouté(s)">
              </bis-integer-inline-input>
          </div>
          <div class="col-md-6">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuPolgendNbPermTot" [max]="9999" enLectureSeule="true"
                classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-10">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuPolgendNbPermEtpTot" [max]="99999" 
                enLectureSeule="true" classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-10">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuPolgendNbVictTot" [max]="999999" 
                  enLectureSeule="true" classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>  
      </div>
    </div>
  </div>
</div>


<div *ngIf="rootForm && lieuxPolgend && (modeRenduService.enModeImpression$ | async)">
  <div class="form-row mx-2 pb-3" *ngIf="rootForm && lieuxPolgend">
    <div class="col" [formGroup]="rootForm">
      <div>
        <div *ngFor="let item of lieuxPolgend.controls; let i = index">
            <div class="form-row">
                <div class="col-md-8">
                   <!--<bis-filtered-select-input-keypad [preId]="i" [rootForm]="lieuxPolgend.controls[i]" 
                      nbChoixVisiblePossible="5" label="aaLieuPolgendCodCom" nomNomenclature="commune">
                   </bis-filtered-select-input-keypad>-->
                   <bis-commune-input-keypad [rootForm]="lieuxPolgend.controls[i]" [preId]="i" nbChoixVisiblePossible=10
                      label="aaLieuPolgendCodCom" nomNomenclature="commune">
                   </bis-commune-input-keypad>
                 </div>
                 <div class="col-md-4">
                   <bis-filtered-select-input-keypad [preId]="i" [rootForm]="lieuxPolgend.controls[i]" 
                   infoBulle="Préciser dans le menu déroulant si le lieu de permanence est en quartier prioritaire" label="aaLieuPolgendQp" nomNomenclature="ouiNonNsp">
                   </bis-filtered-select-input-keypad>
                 </div>
            </div>
            <div class="form-row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                   <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxPolgend.controls[i]" classeColLabel="col-8" classeColInput="col-2" classeSupplInput="text-right" 
                   label="aaLieuPolgendNbPerm" [max]="999" infoBulle="1 demi-journée = 3h" [erreursCroisees]="['ctrlA66Polgend']">
                   </bis-integer-inline-input-keypad>
                   <bis-affiche-erreurs-croisees [rootForm]="lieuxPolgend.controls[i]" colorErreur="danger"
                    labelErreur="ctrlA66Polgend">
                   </bis-affiche-erreurs-croisees>
                 </div>
            </div>
            <div class="form-row">
                 <div class="col-md-1"></div>
                 <div class="col-md-10">
                    <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxPolgend.controls[i]" classeColLabel="col-8" 
                      classeColInput="col-2" classeSupplInput="text-right" label="aaLieuPolgendNbPermEtp" [max]="9999" [erreursCroisees]="['ctrlA67Polgend']"
                      infoBulle="3 personnes présentes sur une demi-journée = 3 demi-journées travaillées">
                    </bis-integer-inline-input-keypad>
                    <bis-affiche-erreurs-croisees [rootForm]="lieuxPolgend.controls[i]" colorErreur="danger"
                      labelErreur="ctrlA67Polgend">
                    </bis-affiche-erreurs-croisees>
                    <bis-affiche-alertes [labelAlerte]="'alertA45Polgend_' + i"></bis-affiche-alertes>
                 </div>
            </div>
            <div class="form-row">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                   <bis-integer-inline-input-keypad [preId]="i" [rootForm]="lieuxPolgend.controls[i]" classeColLabel="col-8" classeColInput="col-2" classeSupplInput="text-right" 
                   label="aaLieuPolgendNbVict" [max]="99999" infoBulle="(physiques et morales)">
                   </bis-integer-inline-input-keypad>
                </div>
           </div>
        </div>
        <div class="form-row mt-4">
            <div class="col-md-6">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuPolgendNb" [max]="99" enLectureSeule="true"
                classeColLabel="col-6" classeColInput="col-4"      
                infoBulle="Cette zone est calculée automatiquement à partir du nombre de commissariat/gendarmerie ajouté(s)">
              </bis-integer-inline-input>
          </div>
          <div class="col-md-6">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuPolgendNbPermTot" [max]="9999" enLectureSeule="true"
                classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-10">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuPolgendNbPermEtpTot" [max]="99999" 
                enLectureSeule="true" classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-10">
              <bis-integer-inline-input [rootForm]="formulaire" label="aaLieuPolgendNbVictTot" [max]="999999" 
                  enLectureSeule="true" classeColLabel="col-6" classeColInput="col-4">
              </bis-integer-inline-input>
          </div>
        </div>  
      </div>
    </div>
  </div>
</div>